import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ReactComponent as Users } from "../../assets/icons/users.svg";
import { useNavigate } from "react-router-dom";

dayjs.extend(relativeTime)

export function NotificationItem({ notification, onClose }: { notification: any; onClose?: () => void }) {
    const navigate = useNavigate();

    const sessionId = notification?.context?.path === "praxisplay-feedback"
        ? notification?.context?.session_id
        : undefined;

    const handleClick = sessionId ? () => {
        navigate(`/praxisplay/session/${sessionId}`, { state: { source: "history" } });
        onClose?.();
    } : undefined;

    return (
        <div
            className={`flex flex-col justify-start items-start border-b border-b-[#ddd]${handleClick ? " cursor-pointer hover:bg-black/5 rounded-sm" : ""}`}
            onClick={handleClick}
        >
            <div className="flex flex-col justify-center items-start">
                <div className="flex justify-start items-center gap-11 pb-2.5 ">
                    <div className="flex justify-start items-start gap-[15px]">
                        <div className="flex justify-center mt-2 items-center relative overflow-hidden w-[34px] h-[34px] bg-[#FEFCE8] rounded-full">
                            <Users className="w-6 h-6" />
                        </div>
                        <div className="flex flex-col justify-start items-start gap-1.5">
                            <div className="justify-start text-black text-base font-medium ">{notification?.category}</div>
                            <div className="self-stretch justify-start text-zinc-600 text-xs font-normal  leading-none">{notification?.text}</div>
                        </div>
                    </div>
                    <div className="opacity-60 text-right justify-start text-black text-[10px] font-normal leading-none whitespace-nowrap">{dayjs(notification?.createdAt).fromNow()}</div>
                </div>
            </div>
        </div>
    )
}